module.exports = __webpack_public_path__ + "static/media/headphonesvrThumb.dc186931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/headphonesvrThumb.jpg
// module id = 396
// module chunks = 0